/**
 * 素材の添付ファイルに関する制約。
 *
 * スケジュール画面のメモ出稿(EventDialog)とメモ画面の編集(Memo/index)の
 * 両方で同じ検証をしていたためここへ集約した。
 * 写真は CTS 側の取り込み条件に合わせて JPEG 固定・10MB までとする。
 */

/** 素材種別（slug）ごとの添付可能ファイル形式。article は添付なし */
export const MATERIAL_FILE_ACCEPT_BY_SLUG: Record<string, string> = {
  photo: 'image/jpeg,.jpg,.jpeg',
  eps: '.eps,application/postscript',
  pdf: '.pdf,application/pdf',
};

/** 写真素材の添付ファイル上限（10MB） */
export const PHOTO_MAX_FILE_SIZE = 10 * 1024 * 1024;

/**
 * 添付ファイルを検証する。問題があればユーザー向けメッセージを返し、
 * 問題なければ空文字を返す。
 * 写真以外の種別と、ファイル未選択のときは検証しない。
 */
export const validateMaterialFile = (slug: string, file: File | null): string => {
  if (slug !== 'photo' || !file) return '';
  const mimeType = (file.type || '').toLowerCase();
  const isJpeg = mimeType ? mimeType === 'image/jpeg' : /\.jpe?g$/i.test(file.name || '');
  if (!isJpeg) {
    return '写真の添付ファイルはJPEG形式（.jpg / .jpeg）のみアップロードできます。';
  }
  if (file.size > PHOTO_MAX_FILE_SIZE) {
    return `写真の添付ファイルは10MBまでです（選択されたファイル: ${(file.size / (1024 * 1024)).toFixed(1)}MB）。`;
  }
  return '';
};
